import { TrainingProductDetailModel, TrainingProductModel } from "@crescentParts/Widgets/CustomApiModels";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface TrainingFormModel {
    Name: string;
    CompanyName: string;
    Phone: string;
    Email: string;
    TM: string;
    PaymentMethod: string;
}

export interface TrainingApiParameter extends ApiParameter {
    trainingForm: Partial<TrainingFormModel>;
}

export interface TrainingEnquiryUrlParameter extends ApiParameter {
    Message: string;
    Email: string;
    Name: string;
}

export interface TrainingProductParameter extends ApiParameter {
    data?: any;
}

const customUrl = "/api/training/sendemail";
const trainingEnquiryUrl = "/api/training/TrainingEnquiry";
const getTrainingProductDetailsUrl = "/api/training/GetTrainingProductDetails";

export async function trainingService(parameter: TrainingApiParameter): Promise<ServiceResult<TrainingFormModel>> {
    try {
        const result = await post<TrainingFormModel>(`${customUrl}`, parameter.trainingForm as TrainingFormModel);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export function trainingEnquiryAPI(parameter: TrainingEnquiryUrlParameter) {
    return post<TrainingEnquiryUrlParameter>(`${trainingEnquiryUrl}`, parameter);
}

export function getTrainingProductData(parameter: TrainingProductParameter) {
    return post<TrainingProductDetailModel>(`${getTrainingProductDetailsUrl}`, parameter.data);
}